import dayjs from "dayjs";
import PdfHeader from "../../../../components/pafHeader";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";

const AllLawyerReport = ({ data, fromDate, toDate, activeTab, selectedMonth, selectedMonthString }) => {
    return <div className="print-page">
        <div className="report-container" style={{ padding: 0, margin: 0 }}>
            <PdfHeader pdfName="Advocate's Report" />
            <div className="total-details flexible">
                {
                    (fromDate && toDate) && <div>
                        <h4 className="information-title">Date</h4>
                        <p style={{ margin: 0, padding: "10px 0px" }}>{fromDate && toDate ? `${dayjs(fromDate).format("DD-MM-YYYY")} to ${dayjs(toDate).format("DD-MM-YYYY")}` : "Nil"}</p>
                    </div>
                }
                {
                    selectedMonth && <div>
                        <h4 className="information-title">Month</h4>
                        <p style={{ margin: 0, padding: "10px 0px" }}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                    </div>
                }
                <div>
                    <h3 className="information-title">Advocate's</h3>
                    <h2 className="information-detail">{data?.length}</h2>
                </div>
            </div>
            <table className="report-table">
                <thead>
                    <tr>
                        <th colSpan={1}>SNo</th>
                        <th colSpan={3}>Date</th>
                        <th colSpan={3}>Advocate ID</th>
                        <th colSpan={5}>Advocate Name / Bar Council ID</th>
                        <th colSpan={5}>Contact Info</th>
                        {
                            activeTab === "REJECTED" ? <>
                                <th colSpan={5}>Specialization</th>
                                <th colSpan={2}>Year of Exp</th>
                                <th colSpan={3}>Qualification</th>
                                <th colSpan={5}>About</th>
                            </> : <>
                                <th colSpan={2}>Total Cons.</th>
                                <th colSpan={2}>Cancellation Count</th>
                                <th colSpan={3}>Earning Amount</th>
                                <th colSpan={2}>Rating</th>
                            </>
                        }
                    </tr>
                </thead>
                <tbody>
                    {data?.map((detail, index) => (
                        <tr key={detail?.id}>
                            <td colSpan={1}>{index + 1}</td>
                            <td colSpan={3}>{detail?.approvalInfo?.approvalDate ? dayjs(detail?.approvalInfo?.approvalDate).format("DD-MM-YYYY") : "Nil"}</td>
                            <td colSpan={3}>{detail?.lawyerNo || "Nil"}</td>
                            <td colSpan={5}>
                                {detail?.firstName || "Nil"} {detail?.middleName || "Nil"} {detail?.lastName || "Nil"}
                                <br />
                                <small>{detail?.barCouncilId || "Nil"}</small>
                            </td>
                            <td colSpan={5}>
                                {detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}
                                <br />
                                <small>{detail?.email || "Nil"}</small>
                            </td>
                            {
                                activeTab === "REJECTED" ? <>
                                    <td>{detail?.specialization?.join(",") || "Nil"}</td>
                                    <td colSpan={2}>{detail?.experience || "Nil"}</td>
                                    <td colSpan={3}>{detail?.qualification || "Nil"}</td>
                                    <td colSpan={5}>{detail?.aboutAs || "Nil"}</td>
                                </> : <>
                                    <td colSpan={2}>{detail?.totalConsultation || "0"}</td>
                                    <td colSpan={2}>{detail?.totalCancelConsultation || "0"}</td>
                                    <td colSpan={3}>&#8377; {formatAmount(detail?.myBalance || 0)}</td>
                                    <td colSpan={2}>{detail?.rating || "0.0"}</td>
                                </>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
};

export default AllLawyerReport
